import React from 'react';
import { graphql } from 'react-apollo';
import { Grid, Checkbox } from "@material-ui/core";
import MUIDataTable from "mui-datatables";

import DeleteLayoutDefinition from './delete';

import { GET } from "../../../queries/layout_definition";
import { LayoutTypesLookup } from "../../layoutTypes/components/lookup";

// components
import DrawerPlacements from '../../../components/DrawerPlacements';
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';
import PageTitle from "../../../components/PageTitle/PageTitle";
import AddLayoutDefinition from '../../../pages/layoutDefinitions/actions/create';
import UpdateLayoutDefinition from '../../../pages/layoutDefinitions/actions/edit';

const layoutDefinition = ({ data: { layoutdefinition, loading, error }}) => {
  const options = {
    selectableRows: 'checkbox',
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <DeleteLayoutDefinition selectedRows = {selectedRows} layoutDefinitions={layoutdefinition}/>
    )
  };
  const ActionsRow = (tableMeta) => {
    var id = tableMeta.rowData[2];
    var title = tableMeta.rowData[0];
    var tag = tableMeta.rowData[1];
    var adWidth = tableMeta.rowData[3] !== undefined ? tableMeta.rowData[3].toString(): "";
    var adHeight = tableMeta.rowData[4] !== undefined ? tableMeta.rowData[4].toString(): "";
    var divElementName = tableMeta.rowData[5];
    var layoutTypeId = tableMeta.rowData[6];
    var isMobile = tableMeta.rowData[7];
    var showCloseButton = tableMeta.rowData[8];
    var customStyle = tableMeta.rowData[9];
    var isHeaderHide = tableMeta.rowData[10];
    var isVideo = tableMeta.rowData[11];
    var isFullImage = tableMeta.rowData[12];
    var imageSizesOverride = tableMeta.rowData[13];
    var isFullAnchor = tableMeta.rowData[14];
    var indexValue = tableMeta.rowData[15] !== null ? tableMeta.rowData[15] : tableMeta.rowData[16];
    var indexType = tableMeta.rowData[15] !== null ? "StaticPlace" : "DynamicPlace";
    var insertion = tableMeta.rowData[17];
    return (
      <>
        <DrawerPlacements title="Edit Layout Definition" iconButtonAction={false} labeButtonAction={title}>
          <UpdateLayoutDefinition 
          id = {id}
          title={title}
          Name = {id}
          tag = {tag}
          indexValue = {indexValue}
          indexType = {indexType}
          adWidth = {adWidth}
          adHeight = {adHeight}
          divElementName = {divElementName}
          layoutTypeId = {layoutTypeId}
          isMobile = {isMobile}
          showCloseButton={showCloseButton}
          customStyle={customStyle}
          isHeaderHide={isHeaderHide}
          isVideo={isVideo}
          isFullImage={isFullImage}
          imageSizesOverride={imageSizesOverride}
          isFullAnchor={isFullAnchor}
          insertion={insertion}
          >

          </UpdateLayoutDefinition>
        </DrawerPlacements>
      </>
    );
  };
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Layout Definitions" />
        </Grid>
        <Grid item xs={2}>
        <DrawerPlacements title="Layout Definition" labeButtonAction="Add">
            <AddLayoutDefinition/>
          </DrawerPlacements>
        </Grid>
      </Grid>
    
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={layoutdefinition}
                columns={[{
                  label   : 'TITLE',
                  name    : 'title',
                  options : {
                    customBodyRender: (value, tableMeta, updateValue) => { 
                      return (ActionsRow(tableMeta))
                    }
                }},{
                  label   : 'TAG',
                  name    : 'tag'
                },{
                  name    : 'id',
                  options : {
                    display : false
                  }
                },
                {
                  label   : 'WIDTH',
                  name    : 'adWidth'
                },{
                  label   : 'HEIGHT',
                  name    : 'adHeight'
                },
                {
                  label   : 'QUERYSELECTOR',
                  name    : 'divElementName',
                  options : {
                    display : false
                  }
                },
                {
                  label: 'LAYOUT',
                  name: "layoutTypeId",
                  options: {
                    filter: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                      return (
                          <LayoutTypesLookup layoutTypeId={value}/>
                      );
                    }
                  }
                },
                {
                  name: "isMobile",
                  options: {
                    filter: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                      return (
                        <Checkbox
                          disabled
                          checked={value}
                          value={value}
                          inputProps={{
                            'aria-label': 'primary checkbox',
                          }}
                        />
                      );
                    }
                  }
                },
                {
                  name: "showCloseButton",
                  options: {
                    filter: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                      return (
                        <Checkbox
                          disabled
                          checked={value}
                          value={value}
                          inputProps={{
                            'aria-label': 'primary checkbox',
                          }}
                        />
                      );
                    }
                  }
                },
                {
                  label   : 'customStyle',
                  name    : 'customStyle',
                  options : {
                    display : false
                  }
                },
                { name    : 'isHeaderHide', options : { display : false } },
                { name    : 'isVideo', options : { display : false } },
                { name    : 'isFullImage', options : { display : false } },
                { name    : 'imageSizesOverride', options : { display : false } },
                { name    : 'isFullAnchor', options : { display : false } },
                { name    : 'tagIndex', options : { display : false } },
                { name    : 'dynamicPlace', options : { display : false } },
                { name    : 'insertion', options : { display : false } },
              ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
    </>
  );
}

export const LayoutDefinition = graphql(GET)((layoutDefinition));